import { Component, OnInit } from '@angular/core';
import { DynamicCssService } from '../../services/dynamic-css/dynamic-css.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'dynamic-css',
  templateUrl: './dynamic-css.component.html',
  styleUrls: ['./dynamic-css.component.scss']
})
export class DynamicCssComponent implements OnInit {
  cssVariables: any;
  styles: string;

  constructor(
    public dynamicCssService: DynamicCssService, 
    public domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.dynamicCssService.getCss().subscribe(
      (rep) => {
        this.cssVariables = rep[0];
        this.updateStyles();
        this.applyKendoStyles(this.cssVariables.couleur);
      },
      (error) => {
        console.error('Failed to load CSS variables', error);
      }
    );
  }

  updateStyles() {
    this.styles = this.generateCssStyles(this.cssVariables.couleur);
  }

  generateCssStyles(color: string): string {
    return `<style>

        .swal2-container {
          z-index: 20000 !important;
        }

        .uk-accordion-title {
          background-color: ${color} !important;
          color: ${this.getContrastYIQ(color)} !important;
        }

        /* Liens spécifiques à .uk-accordion-title */
        .uk-accordion-title:hover {
          color: ${this.getContrastYIQ(color)} !important;
        }

        .uk-accordion-title:visited {
          color: ${this.getContrastYIQ(color)} !important;
        }

        .uk-accordion-title:active {
          color: ${this.getContrastYIQ(color)} !important;
        }

        .uk-accordion-title:link {
          color: ${this.getContrastYIQ(color)} !important;
        }

        .primary-background{
          background-color: ${color} !important;
        }

        .dyn-prim-bg-color {
          background-color: ${color} !important;
          color: ${this.getContrastYIQ(color)} !important;
        }

        .primary-border{
          border-color: ${color} !important;
        }

        .border-color-btn{
          border-color: ${color} !important;
        }

        .form-input input:valid{
          border-bottom: 2px solid ${color} !important;
        }

        .form-input input:focus{
          border-bottom: 2px solid ${color} !important;
        }

        .form-input input:valid + .placeholder{
          color: ${color} !important;
        }

        .form-input input:focus + .placeholder{
          color: ${color} !important;
        }

        .k-tabstrip-top > .k-tabstrip-items{
          background-color: ${color} !important;
        }

        .account-theme .k-tabstrip-top > .k-tabstrip-items > .k-state-active{
          background-color: ${this.getLightenDarkenColor(color, -50)} !important;
        }

        .k-panelbar>.k-panelbar-header>.k-link.k-selected:hover, .k-panelbar>.k-panelbar-header>.k-link.k-selected.k-hover {
          background-color: ${color} !important;
        }

        .k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {
          background-color: ${color} !important;
        }

        .k-dialog-titlebar{
          background-color: ${color} !important;
        }

        .k-multiselect-wrap{
          border-color: ${color} !important;
        }

        .k-button{
          background-color: ${color} !important;
          color: ${this.getContrastYIQ(color)} !important;
        }

        .k-button-icon {
          color: ${this.getContrastYIQ(color)} !important;
        }

        .k-button-text {
          color: ${this.getContrastYIQ(color)} !important;
        }

        /* Lien par défaut */
        a:link {
          color: ${color} !important;
        }

        /* Lien visité */
        a:visited {
          color: ${this.getLightenDarkenColor(color, +30)} !important;
        }

        /* Lien au survol */
        a:hover {
          color: ${this.getLightenDarkenColor(color, +20)} !important;
        }

        /* Lien au clic (lorsqu'il est actif) */
        a:active {
          color: ${this.getLightenDarkenColor(color, +30)} !important;
        }

        .k-time-header{
          color: ${this.getContrastYIQ(color)} !important;
        }

        .k-textbox{
          border-color: ${color} !important;
        }

        .k-panelbar > .k-item:first-child{
          background-color: ${color} !important;
        }

        .account-theme .k-picker-wrap{
          border-color: ${color} !important;
        }

        .all-items-primary-background > .k-item{
          background-color: ${color} !important;
        }

        .cssload-thecube .cssload-cube:before {
          background-color: ${color} !important;

        }

        .k-input-inner:not(kendo-dropdownlist .k-input-inner) {
            border-bottom: none !important;
            box-shadow: none !important;
            height: 100% !important;
            padding-block: 0 !important;
            padding-inline: 0 !important;
        }

      .card {
        border-radius: 12px !important;
      }
      .titre-card {
        border-top-left-radius: 12px !important;
        border-top-right-radius: 12px !important;
      }
      .titre-carte {
        border-top-left-radius: 12px !important;
        border-top-right-radius: 12px !important;
      }
      .btn {
        border-radius: 25px !important;
      }
      .k-grid-pager {
        border-bottom-left-radius: 12px !important;
        border-bottom-right-radius: 12px !important;
      }
      .k-grid-toolbar {
        border-top-left-radius: 12px !important;
        border-top-right-radius: 12px !important;
      }
      .k-grid {
        border-radius: 12px !important;
      }
      .k-upload {
        border-radius: 12px !important;
      }
      .k-upload {
        border-radius: 12px !important;
      }
      .k-dropzone {
        border-radius: 12px !important;
      }

      ::selection {
        background: ${color} !important;

      }

      :root {
        --prim-color: ${color} !important;

      }

      .active{
        color: ${color} !important;
        background: linear-gradient(to left, ${color} 5px, rgba(255, 255, 255, 0) 4px) !important;
      }

      .menu-item-icon-badge::before {
        background-color: ${color} !important;
      }


      progress::-webkit-progress-value {
        background-color: ${color} !important;
      }

      .checkbox:checked:before{
        border-color: ${color} !important;
      }

      .k-switch-on .k-switch-handle{
        background-color: ${color} !important;
      }

      .account-theme .k-dropdown-wrap, .account-theme .k-dropdown-wrap,
      .account-theme .k-numeric-wrap, .account-theme .k-numeric-wrap {
        border-color: ${color} !important;
      }

      .account-theme .k-button.k-primary {
        background-color: ${color} !important;
        color: white !important;
      }

      .account-theme .k-panelbar > .k-item {
        background-color: ${color};
      }

      .argalis-badge {
        background-color: ${this.getLightenDarkenColor(color, -30)} !important;
      }

      .primary-darken {
        background-color: ${this.getLightenDarkenColor(color, -30)} !important;
      }

      .k-state-selected {
        color: white !important;
      }
      </style>`;
  }

  applyKendoStyles(color: string) {
    const root = document.documentElement;
    root.style.setProperty('--kendo-color-primary', color);
    root.style.setProperty('--kendo-color-secondary', this.getLightenDarkenColor(color, -30));
    root.style.setProperty('--kendo-color-primary-hover', this.getLightenDarkenColor(color, -10));
    root.style.setProperty('--kendo-color-primary-active', this.getLightenDarkenColor(color, -20));
    root.style.setProperty('--kendo-color-primary-on-surface', color);
    root.style.setProperty('--kendo-color-on-primary', this.getContrastYIQ(color));
  }


  getStyles() {
    return this.domSanitizer.bypassSecurityTrustHtml(this.styles);
  }

  getLightenDarkenColor(col, amt) {
    let usePound = false;
    if (col[0] === '#') {
        col = col.slice(1);
        usePound = true;
    }
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) {
      r = 255;
    } else if  (r < 0) {
      r = 0;
    }

    let b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) {
      b = 255;
    } else if  (b < 0) {
      b = 0;
    }

    let g = (num & 0x0000FF) + amt;
    if (g > 255) {
      g = 255;
    } else if  (g < 0) {
      g = 0;
    }
    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
  }

  getContrastYIQ(hexcolor) {
    if (hexcolor[0] === '#') {
      hexcolor = hexcolor.slice(1);
    }

    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
  }
}
